import {FC} from 'react'
import {useFormContext} from 'react-hook-form'
import {InputDate} from '../../Input'
import {InputTextWrapper, InputNumberWrapper} from '../Input'
interface Props {
  isDisabled?: boolean
}
const AditionalForm: FC<Props> = ({isDisabled = false}) => {
  const {
    register,
    formState: {errors},
  } = useFormContext()

  return (
    <div className='row'>
      <div className='col-sm-12 col-md-4 col-xl-3'>
        <InputTextWrapper
          labelText='Texto adicional 1'
          name='campoadicionaltxt1'
          textPlaceholder='Escribe el texto adicional'
          disabled={isDisabled}
        />
      </div>
      <div className='col-sm-12 col-md-4 col-xl-3'>
        <InputTextWrapper
          labelText='Texto adicional 2'
          name='campoadicionaltxt2'
          textPlaceholder='Escribe el texto adicional'
          disabled={isDisabled}
        />
      </div>
      <div className='col-sm-12 col-md-4 col-xl-3'>
        <InputTextWrapper
          labelText='Texto adicional 3'
          name='campoadicionaltxt3'
          textPlaceholder='Escribe el texto adicional'
          disabled={isDisabled}
        />
      </div>
      <div className='col-sm-12 col-md-4 col-xl-3'>
        <InputTextWrapper
          labelText='Texto adicional 4'
          name='campoadicionaltxt4'
          textPlaceholder='Escribe el texto adicional'
          disabled={isDisabled}
        />
      </div>
      <div className='col-sm-12 col-md-4 col-xl-3'>
        <InputTextWrapper
          labelText='Texto adicional 5'
          name='campoadicionaltxt5'
          textPlaceholder='Escribe el texto adicional'
          disabled={isDisabled}
        />
      </div>
      <div className='col-sm-12 col-md-4 col-xl-3'>
        <InputNumberWrapper
          labelText='Número adicional 1'
          name='campoadicionalnum1'
          textPlaceholder='Escribe el número'
          disabled={isDisabled}
        />
      </div>
      <div className='col-sm-12 col-md-4 col-xl-3'>
        <InputNumberWrapper
          labelText='Número adicional 2'
          name='campoadicionalnum2'
          textPlaceholder='Escribe el número'
          disabled={isDisabled}
        />
      </div>
      <div className='col-sm-12 col-md-4 col-xl-3'>
        <InputNumberWrapper
          labelText='Número adicional 3'
          name='campoadicionalnum3'
          textPlaceholder='Escribe el número'
          disabled={isDisabled}
        />
      </div>
      <div className='col-sm-12 col-md-4 col-xl-3'>
        <label>Fecha adicional 1:</label>
        <InputDate
          name='campoadicionalFec1'
          register={register}
          errors={errors}
          disabled={isDisabled}
        />
      </div>
      <div className='col-sm-12 col-md-4 col-xl-3'>
        <label>Fecha adicional 2:</label>
        <InputDate
          name='campoadicionalFec2'
          register={register}
          errors={errors}
          disabled={isDisabled}
        />
      </div>
    </div>
  )
}

export default AditionalForm
